import React, {useEffect, useState} from "react";
import type { ContextProps } from '../../../../types';
import {PageTitle} from "../../../../Components/Landmarks";
import {LayoutFullBleed} from "../../../../Components/Layout";
import {locations} from "../../../../Utilities/Location";
import {isArrayNullOrEmpty} from "../../../../Utilities/Types/arrayUtilities";
import {aphCatalogApi} from "./aphCatalogApi";
import {AphCatalogItem} from "./AphCatalogItem";
import {SYSTEM_TYPES} from "../../libraryConstants";
import {getSystemTypeTextByValue} from "../../libraryUtility";

export const AphCatalogWhatsNewContainer = ({
                                                handleApiCall,
                                                redirect,
                                            }: ContextProps) => {
    const [resources, setResources] = useState<Record<string, any>[]>([]);

    const handleEdit = (id: string) => {
        const path = locations.APH_CATALOG_ITEM.getLink([id, SYSTEM_TYPES.APH]).to;
        redirect(path);
    }

    useEffect(() => {
        const getResources = () => {
            handleApiCall(() => aphCatalogApi.getWhatsNew(), (results: Record<string, any>[]) => setResources(results));
        }

        getResources();
    }, []);

    return <>
        <PageTitle h1={getSystemTypeTextByValue(SYSTEM_TYPES.APH.toString())}/>

        <LayoutFullBleed className={`catalog`}>
            <header>
                <h2>What&apos;s New</h2>
            </header>

            {
                resources.map((resource: Record<string, any>) => {
                    const handleClickEdit = () => handleEdit(resource.id);
                    return <AphCatalogItem
                        key={resource.id}
                        handleClickEdit={handleClickEdit}
                        {...resource}
                    />;
                })
            }
            {
                isArrayNullOrEmpty(resources) &&
                <p className={`text-center`}>No results.</p>
            }

        </LayoutFullBleed>
    </>;
};
